import React from "react";
import { useSelector } from "react-redux";
import { ThemeType } from "../../../../../redux/constants";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import { selectAllRegistration } from "../../../../../redux/slices/registrationSlice";
import { selectHasParentRegistration } from "../../../../../redux/slices/appSettingsSlice";
import { selectAllClassifications } from "../../../../../redux/slices/classificationsSlice";
import {
    selectAllP2pSettings,
    selectBaseUrl,
} from "../../../../../redux/slices/p2pSettingsSlice";
import ClassificationSummary from "./ClassificationSummary";
import { selectIsCms } from "../../../../../redux/slices/configSlice";

const ConnectedClassificationSummary = () => {
    const isCms = useSelector(selectIsCms);
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const { classification } = useSelector(selectAllRegistration);
    const { Classification = [] } = classification;
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );
    const {
        p2pActionSettings: { changeParticipantDetailsLinkLabel = "Change" },
    } = themeSettings;
    const classifications = useSelector(selectAllClassifications);
    const { enableClassifications, classificationLabel } =
        useSelector(selectAllP2pSettings);
    const baseUrl = useSelector(selectBaseUrl);

    const isVisible =
        enableClassifications &&
        classifications.length > 0 &&
        Classification.length > 0;

    const classificationName =
        Classification.length > 0
            ? classifications?.find(({ id }) => `${id}` === Classification[0])
                  ?.title
            : "";

    const classificationSummaryProps = {
        baseUrl,
        classificationLabel,
        classificationName,
        changeParticipantDetailsLinkLabel,
        hasParentRegistration,
        isVisible,
        isCms,
    };

    return <ClassificationSummary {...classificationSummaryProps} />;
};

export default ConnectedClassificationSummary;
